import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/dashboard",
          name: "Dashboard",
          component: () => import("@/view/pages/Dashboard.vue"),
        },
        {
          path: "/users/:type",
          name: "UserList",
          component: () => import("@/view/pages/user/UserList.vue"),
        },
        {
          path: "/users/:type/:userId",
          name: "UserDetail",
          component: () => import("@/view/pages/user/UserDetail.vue"),
        },
        {
          path: "/event/events/:userId?",
          name: "EventList",
          component: () => import("@/view/pages/event/EventList.vue"),
        },
        {
          path: "/event/posts",
          name: "PostList",
          component: () => import("@/view/pages/event/PostList.vue"),
        },
        {
          path: "/event/:eventId/coupons",
          name: "EditCoupon",
          component: () => import("@/view/pages/coupon/EditCoupon.vue"),
        },
        {
          path: "/coupons/:influencerId",
          name: "CouponList",
          component: () => import("@/view/pages/coupon/CouponList.vue"),
        },
        {
          path: "/story",
          name: "StoryList",
          component: () => import("@/view/pages/story/StoryList.vue"),
        },
        {
          path: "/transaction/transactions/u/:userId?",
          name: "TransactionListByUserId",
          component: () =>
            import("@/view/pages/transaction/TransactionList.vue"),
        },
        {
          path: "/transaction/transactions/:eventId?",
          name: "TransactionListByEventId",
          component: () =>
            import("@/view/pages/transaction/TransactionList.vue"),
        },
        {
          path: "/transaction/refund/:eventId?",
          name: "RefundListByEventId",
          component: () => import("@/view/pages/transaction/RefundList.vue"),
        },
        {
          path: "/transaction/withdraws/u/:userId?",
          name: "WithdrawListByUserId",
          component: () => import("@/view/pages/transaction/WithdrawList.vue"),
        },
        {
          path: "/transaction/withdraws/:eventId?",
          name: "WithdrawListByEventId",
          component: () => import("@/view/pages/transaction/WithdrawList.vue"),
        },
        {
          path: "/report/:type",
          name: "ReportList",
          component: () => import("@/view/pages/report/ReportList.vue"),
        },
        {
          path: "/system/change_password",
          name: "ChangePassword",
          component: () => import("@/view/pages/system/ChangePassword.vue"),
        },
        {
          path: "/system/send_message",
          name: "SendMessage",
          component: () => import("@/view/pages/system/SendMessage.vue"),
        },
        {
          path: "/system/alarm_list",
          name: "AlarmList",
          component: () => import("@/view/pages/system/AlarmList.vue"),
        },
        {
          path: "/debug/paypalWebHook",
          name: "PayPalWebHook",
          component: () => import("@/view/pages/debug/PayPalWebHook.vue"),
        },
        {
          path: "/debug/temp",
          name: "TransactionTemp",
          component: () => import("@/view/pages/debug/TransactionTemp.vue"),
        },
        {
          path: "/debug/buyTicket",
          name: "BuyTicket",
          component: () => import("@/view/pages/debug/BuyTicket.vue"),
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/view/pages/Login.vue"),
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/Page404.vue"),
    },
  ],
});
